import indexedDB from '@/utils/indexedDB';
import { callAPI } from '@/store/socket';
import { sneakyPromise } from './store/profiling';

const context = {
  callsQueue: [],
  connectedSocket: true,
  waitNextCheck: null,
  checkingQueue: false
};

export function persistCalls(data) {
  console.log('🟡 save to indexedDB/levelDB => ', data);
  indexedDB.saveData({
    data,
    dataId: 'requests',
    dbName: 'offlineRequests',
  });
}

export async function execQueue() {
  console.log('🟡 Start execQueue');
  if (context.callsQueue.length) {
    const { method, params, cb } = context.callsQueue[0];
    console.log('🟡 Make actual CallAPI method:', method);
    const resp = await callAPI({
      method,
      params,
      dontWaitIfNoConn: true,
      persisted: true,
    });

    if (cb) {
      try {
        cb(resp);
      } catch (e) {
        console.error(e);
      }
    }

    console.log('🟡 RESPONSE CallAPI:', resp);

    if (resp && resp.noConnectionError) {
      context.connectedSocket = false;
      console.log("Can't run API, persisting calls, resp:", resp);
      persistCalls(context.callsQueue);
      return false;
    }

    if (resp && !resp.success) {
      console.log('🔴🔴🔴 >>> response persisted call error', resp);
    }

    context.callsQueue.shift();
    persistCalls(context.callsQueue);
    if (resp && resp.success) {
      // if found out that startTrack executed after 10 seconds after user started tracking, because stopTrack made instant call and
      // postponed queue porcessing, we can run next call instantly without waiting
      // So I added this fix to test whether it will be ok: if success, we can run next call instantly without waiting
      setTimeout(() => {
        execQueue();
      }, 0);
    }
    return true;
  }
  return false;
}

// must be lower then largest timeout in persisted call
const MAX_WAIT_FOR_EXEC_QUEUE_MS = 20e3;

export const checkQueue = async () => {
  // const lengthQueue = context.callsQueue.length;
  // console.log(`🔵 Start checking queue => ${lengthQueue}`);

  if (!context.connectedSocket) {
    context.checkingQueue = false;
    console.log('🟠 Exit "checking queue" no connection');
    return;
  }

  if (context.checkingQueue) {
    console.log('🟠 Exit "checking queue" checking');
    return;
  }

  context.checkingQueue = true;
  if (context.waitNextCheck) {
    // console.log('🟠 waitNextCheck');
    clearTimeout(context.waitNextCheck);
    context.waitNextCheck = null;
  }

  if (context.callsQueue.length) {
    let executed = true;
    while (executed) {
      // eslint-disable-next-line no-await-in-loop
      executed = await Promise.race([
        execQueue(),
        sneakyPromise(res => setTimeout(() => res(false)), MAX_WAIT_FOR_EXEC_QUEUE_MS),
      ]);
    }
  }
  // console.log('🟠 After execQueue');
  context.checkingQueue = false;
  context.waitNextCheck = setTimeout(checkQueue, 10 * 1000);
};

export function initPersistedCalls(stateRequests) {
  if (stateRequests) {
    context.callsQueue = stateRequests || [];
  }
  checkQueue();
}

export async function callAPIPersisted(method, params, cb) {
  console.log(`💾💾💾💾 Persist call method: ${method}`);
  context.callsQueue.push({ method, params: JSON.parse(JSON.stringify(params)), cb });
  await checkQueue();
  console.log(`🟡 Saving persist calls => ${context.callsQueue.length}`);
  persistCalls(context.callsQueue);
}

export async function startCallQueue() {
  context.connectedSocket = true;
  await checkQueue();
}
